<script>
  import Dialog from 'smelte/src/components/Dialog/Dialog.svelte'
  import { Button } from 'smelte'

  export let proceedConfirmed = false
  export let show = true

  function okButtonClick () {
    proceedConfirmed = true
    show = false
  }
</script>


<div class="relative w-full h-full items-center justify-center select-none">
    <div class="absolute" style="z-index: 9000;">
        <Dialog bind:value={show} persistent={false}>
            <div class="flex flex-col p-6 space-y-4 text-gray-700">
                <div class="text-xl flex justify-start">Information</div>
                <div class="text-lg flex justify-start pb-4">
                    Only the first 30 rows of data will be exported.
                </div>
                <div class="flex space-x-4 items-end justify-end">
                    <Button outlined color="red" on:click={() =>{show = false}}>Cancel</Button>
                    <Button color="red" on:click={okButtonClick}>OK</Button>
                </div>
            </div>
        </Dialog>
    </div>
</div>